import React, { useEffect, useState, useMemo } from "react";
import { Container, Input, Form } from "reactstrap";
import { useFormik } from "formik";
import { Loading } from "../../share/loading";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import './ProposalStyle.css'
import CreateTableHaveFooter from "../../share/CreateTableHaveFooterComponent";

export function InformationForBorrowingTrainComponent() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [month, setMonth] = useState("")
  const [meetingNo, setMeetingNo] = useState("")
  const [monthSelect, setMonthSelect] = useState([]);
  const [meetingNoSelect, setMeetingNoSelect] = useState([]);
  // console.log(meetingNoSelect)
  // const [meetingDate, setMeetingDate] = useState("")
  // console.log("meetingNo",meetingNo)
  // console.log("meetingDate",meetingDate)
  // console.log("month",month)

  useEffect(() => {
    async function GetBorrowMeetingApproveTrainTypeData() {
      setLoading(true)
      try {
        let res = await fetch(`api/ProposalBorrow/getBorrowMeetingApporveTrainType/${month}/${meetingNo}/`);
        let resJson = await res.json();
        // console.log(resJson.dataenum)
        setData(resJson.dataenum)
      } catch (e) {
        // console.log("err =>", e)
      } finally {
        setLoading(false)
      }
    }
    GetBorrowMeetingApproveTrainTypeData()
  }, [month, meetingNo])

  const fromInitialValues = {
    month: "",
    meetingNo: "",
    meetingDate: ""
  }


  const formik = useFormik({
    initialValues: fromInitialValues,
  })

  const changeFormatMeetingNo = (e) => {
    let oldFormat = e.target.value
    let newFormat = oldFormat.replace("/", "-")
    // console.log(newFormat)
    setMeetingNo(newFormat)
  }
  useEffect(() => {
    async function GetMonthForSelect() {
      setLoading(true)
      try {
        let res = await fetch(`api/ProposalBorrow/getMonthTrainSelect`);
        let resJson = await res.json();
        // console.log(resJson.dataenum)
        setMonthSelect(resJson.dataenum.filter((item) => {
          return item.month !== null
        }));
        // console.log("borrowInfo", resJson.dataenum);
      } catch (e) {
        // console.log("err =>", e)

      } finally {
        setLoading(false)
      }
    }
    GetMonthForSelect()

  }, [])

  async function GetMeetingNoSelect(e) {
    let postData = new FormData()
    postData.append("month", e.target.value)
    try {
      let res = await fetch(`api/ProposalBorrow/getMeetingNoTrainSelect`, {
        method: "POST",
        body: postData
      });
      let resJson = await res.json();
      // console.log(resJson.dataenum)
      setMeetingNoSelect(resJson.dataenum.filter((item) => {
        return item.meetingNo !== null
      }));
      // console.log("borrowInfo", resJson.dataenum);
    } catch (e) {
      // console.log("err =>", e)

    }
  }
  const COLUMNS = [
    {
      Header: "ลำดับ",
      accessor: (_row, i) => i + 1,

    },
    {
      Header: "ชื่อสถานประกอบกิจการ",
      accessor: "employee",
      Footer: () => {
        return (
          <div className="text-right">รวม</div>
        );
      },

    },
    {
      Header: "วงเงินขอกู้ (บาท)",
      accessor: "amountLimit",
      Cell: ({ row, value }) => {
        return (
          <>{NumberWithCommas(value ?? 0)}</>
        )
      },
      Footer: ({ data }) => {
        const sum = useMemo(
          () =>
            data?.reduce((acc, row) => {
              return acc + row?.amountLimit ?? 0;
            }, 0),
          [data]
        );
        return <div className="text-center">{NumberWithCommas(sum)}</div>;
      }
    },
    {
      Header: "วงเงินอนุมัติ (บาท)",
      accessor: "amountApprove",
      Cell: ({ row, value }) => {
        return (
          <>{NumberWithCommas(value ?? 0)}</>
        )
      },
      Footer: ({ data }) => {
        const sum = useMemo(
          () =>
            data.reduce((acc, row) => {
              return acc + row?.amountApprove ?? 0;
            }, 0),
          [data]
        );
        return <div className="text-center">{NumberWithCommas(sum)}</div>;
      }
    },
    {
      Header: "จำนวนหลักสูตร/จำนวนรุ่น",
      accessor: "countCourseRequest",
      Cell: ({ row, value }) => {
        return (
          <>{NumberWithCommas(value ?? 0)} / {NumberWithCommas(row?.original?.countClassRequest ?? 0)}</>
        )
      },
    },

    {
      Header: "หน่วยงานที่รับคำขอ",
      accessor: "site",
    },
    {
      Header: "หมายเหตุ",
      accessor: "remarkPromotion",
    },

  ]

  return (
    <Container>
      {!loading ? (
        <>
          <div className="d-flex flex-column justify-content-center align-items-center mb-2">
            <Form
              className="d-flex align-items-center justify-content-end w-75"
              onSubmit={formik.handleSubmit}
              autoComplete="off"
            >
              <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                <span className="w-75 text-center">ประจำเดือน</span>
                <Input
                  name="month"
                  type="select"
                  className="text-center w-100 input-color rounded-pill"
                  onChange={(e) => {
                    formik.handleChange(e)
                    GetMeetingNoSelect(e)
                    setMonth(e.target.value)
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.month}
                >
                  <option defaultValue={"กรุณาเลือก"}>
                    กรุณาเลือก
                  </option>
                  {monthSelect.map((item, i) => (
                    <option key={item.month} value={item.month}>
                      {item.month}
                    </option>
                  ))}
                </Input>
              </div>
              <div className="d-flex align-items-center justify-content-start w-50 mx-1">
                <span className="w-75 text-center">ประชุมครั้งที่</span>
                <Input
                  name="meetingNo"
                  type="select"
                  className="text-center w-100 input-color rounded-pill"
                  onChange={(e) => {
                    formik.handleChange(e)

                    changeFormatMeetingNo(e)
                    // setMeetingNo(e.target.value)
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.meetingNo}
                >
                  <option defaultValue={"กรุณาเลือก"}>
                    กรุณาเลือก
                  </option>
                  {meetingNoSelect.map((item) => (
                    <option value={item.meetingNo}>
                      {item.meetingNo}
                    </option>
                  ))}
                </Input>

              </div>

            </Form>

          </div>
          <CreateTableHaveFooter dataInput={data} column={COLUMNS} />
        </>
      ) : (<Loading />)}

    </Container>
  )
}